import { React, useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';

export default function AliveMembershipSelectBox(props) {
  const { value, setValue, options } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

	const [isClicked, setIsClicked] = useState(false);

	const TopLevelRef = useRef();
	const SelectRef = useRef()
	
  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      SelectRef.current.style.border = `0px`;
      SelectRef.current.style.maxHeight = `0px`;
      SelectRef.current.style.overflowY = 'hidden';
      setTimeout(() => setIsClicked(false), 300);
    }
  }

  // 셀렉트 박스 클릭시 //
	function onClick() {
    if (options.length === 0) {
      alert('회원권이 존재하지 않습니다.\n회원님의 회원권을 추가해주세요!');
			return;
		}

		if (isClicked) {
			SelectRef.current.style.border = `0px`;
			SelectRef.current.style.maxHeight = `0px`;
			SelectRef.current.style.overflowY = 'hidden';
			setTimeout(() => setIsClicked(false), 300);
		}
		else {
			SelectRef.current.style.border = `1px solid ${theme.primary}`;
			SelectRef.current.style.maxHeight = '240px';
			SelectRef.current.style.overflowY = 'auto';
			setIsClicked(true);
		}
	}

  // 데이터 선택시 //
	function optionalClick(index) {
    setValue(options[index]);
	}

	return (
    <TopLevelWrapper ref={TopLevelRef}>
      <ViewBox
        isClicked={isClicked}
        buttonPath={isClicked ? SelectOnPath : SelectOffPath}
        onClick={onClick}>
        <ViewText>{value.membershipName}</ViewText>
      </ViewBox>
      <SelectBox
        ref={SelectRef}
        isClicked={isClicked}
        buttonPath={isClicked ? SelectOnPath : SelectOffPath}
        onClick={onClick}>
        {
          isClicked ?
            options.map((data, index) =>
              <OptionWrapper key={index} onClick={() => optionalClick(index)}>
                <Option>{data.membershipName}</Option>
              </OptionWrapper>
            )
            :
            <OptionWrapper>
              <Option>
                {
                  value.name
                }
              </Option>
            </OptionWrapper>
        }
      </SelectBox>
    </TopLevelWrapper>
	)
}

const TopLevelWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

	width: 100%;
	height: 32px;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

	width: 100%;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;

  overflow: hidden;

  background: url(${props => props.buttonPath}) no-repeat 99% ${props => props.isClicked ? `3` : `55`}%;
  background-color: ${props => props.disabled ? props.theme.buttonFill : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

`;

const ViewText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
  margin: 0 0 0 8px;
`;

const SelectBox = styled.div`
	position: absolute;

	display: flex;
	flex-direction: column;

	justify-content: flex-start
	align-items: flex-start;

  margin-top: 38px;

	width: 100%;
	height: auto;
	max-height: 0px;

	border-radius: 5px;
	overflow: hidden;

	background-color: ${props => props.theme.subBackground};

  transition: max-height 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Option = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	margin: 6px 0 6px 8px;
	color: ${props => props.theme.text};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;